import axios from 'axios';

axios.defaults.withCredentials = true;


if(process.env.NODE_ENV === 'production') {
	axios.defaults.baseURL = `${process.env.VUE_APP_API_URL}/api`;
}
else {
	axios.defaults.baseURL = "/api";
}

axios.defaults.headers = {
    'Accept': 'application/json',
}

axios.defaults.params = {};
axios.interceptors.request.use(function (config) {
	if(config.params && window._event_token) {
		config.params['_event_token'] = window._event_token;
	}
	return config;
}, function (error) {
	return Promise.reject(error);
});

export default axios;